<script lang="ts">
  import type { Snippet } from 'svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { ResponsiveVars } from '@twist/core';
  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(12, 15))
    .addFluid('letter-spacing', toFluidVarInput(1, 1))
    .toCSS();
</script>

<div class={responsiveVars}>
  {@render children?.()}
</div>

<style lang="scss">
  @import 'src/scss/variables';

  div {
    display: block;
    text-transform: uppercase;
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: var(--font-size);
    letter-spacing: var(--letter-spacing);
    line-height: 130%;
    color: $text-default-color;
  }
</style>
